import React from "react";

export default function VerticalLogoSlider({
  partnerLogos = [],
  type,
  partnerDetails,
}) {
  // Create rows
  const rows = [];

  for (let i = 0; i < partnerLogos?.length; i += 3) {
    rows?.push(partnerLogos.slice(i, i + 3));
  }

  const repeatCount = rows?.length > 0 ? Math.ceil(12 / rows?.length) : 0;
  const infiniteRows =
    repeatCount > 0 ? Array(repeatCount)?.fill(rows)?.flat() : [];

  return (
    <div className="business-partners-logo-container">
      <div className="our-business-partners-header">
        <strong className="our-business-partners">
          {partnerDetails?.partnerSponsorsSliderTitle ??
            "Our Business Partners"}
        </strong>
      </div>

      {infiniteRows?.length === 0 ? (
        <div className="vertical-logo-no-data">
          No partner logos are currently available
        </div>
      ) : (
        <div className="slider">
          <div className="track">
            {infiniteRows?.map((row, rowIndex) => (
              <div className="row" key={rowIndex}>
                {row?.map((partner, index) => (
                  <div
                    className="card"
                    key={index}
                    onClick={() => {
                      if (!partner?.urlLink) return;

                      window.open(
                        partner?.urlLink.startsWith("https://")
                          ? partner?.urlLink
                          : `https://${partner?.urlLink}`,
                        "_blank",
                      );
                    }}
                  >
                    <img src={partner?.mediaLink?.url} alt="logo" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
